import { Box, Typography } from '@mui/material';

import Question from '../../Reimbursement/components/Question';
import WhyImportantLink from '../../components/WhyImportantLink';
import { ACCOUNTING_SETUP_HELP_CONTEXT } from '../../hooks/useOpenAccountingSetupHelp';

interface QuestionOption {
    value: string;
    label: string;
}

interface QuestionData {
    id: string;
    question: string;
    value: string | null;
    options?: QuestionOption[];
    helperText?: string;
}

interface QuestionSectionProps {
    title?: string;
    questions: QuestionData[];
    onQuestionChange: (questionId: string, value: string) => void;
    helpQuestion?: string; // Contextual help message for this section
}

export default function QuestionSection({
    title = '',
    questions,
    onQuestionChange,
    helpQuestion = '',
}: QuestionSectionProps) {
    return (
        <Box sx={{ width: '100%' }}>
            {/* Section Header */}
            {title ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 2,
                        borderBottom: 1,
                        borderBottomColor: 'divider',
                    }}>
                    <Typography variant="h4" color="text.primary">
                        {title}
                    </Typography>
                    <WhyImportantLink
                        context={ACCOUNTING_SETUP_HELP_CONTEXT.uploadDocuments}
                        helpQuestion={helpQuestion}
                    />
                </Box>
            ) : null}

            {/* Questions */}
            <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 4 }}>
                {' '}
                {/* 32px gap between questions (matches Figma) */}
                {questions.map((question) => (
                    <Question
                        key={question.id}
                        question={question.question}
                        value={question.value}
                        onChange={(value) => onQuestionChange(question.id, value)}
                        options={question.options}
                        helperText={question.helperText}
                    />
                ))}
            </Box>
        </Box>
    );
}
